import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const ENDPOINT = `${BACKEND_URL}/api/diagnostics/error`;

// Simple in-memory dedup to avoid spamming when an error fires repeatedly
const _sent = new Set();
const KEY_TTL_MS = 60_000; // 1 min

function _key(message, source) {
  return `${source || 'unknown'}::${(message || '').slice(0, 120)}`;
}

export async function reportClientError({ message, stack, source, componentStack }) {
  if (!message) return;
  const k = _key(message, source);
  if (_sent.has(k)) return;
  _sent.add(k);
  setTimeout(() => _sent.delete(k), KEY_TTL_MS);

  const token = (() => {
    try { return localStorage.getItem('muzi_token'); } catch { return null; }
  })();

  try {
    await axios.post(ENDPOINT, {
      message: String(message).slice(0, 1000),
      stack: stack ? String(stack).slice(0, 8000) : undefined,
      component_stack: componentStack ? String(componentStack).slice(0, 4000) : undefined,
      source: source || 'unknown',
      url: typeof window !== 'undefined' ? window.location.pathname : undefined,
      user_agent: typeof navigator !== 'undefined' ? navigator.userAgent : undefined,
    }, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
      timeout: 5000,
    });
  } catch (err) {
    // never let the reporter itself crash the app — just trace it
    console.warn('[errorReporter] failed to POST error:', err?.message || err);
  }
}

let _installed = false;
export function installGlobalErrorReporters() {
  if (_installed || typeof window === 'undefined') return;
  _installed = true;

  window.addEventListener('error', (e) => {
    reportClientError({
      message: e?.message || 'Uncaught error',
      stack: e?.error?.stack,
      source: 'window',
    });
  });

  window.addEventListener('unhandledrejection', (e) => {
    const reason = e?.reason;
    const msg = reason?.message || (typeof reason === 'string' ? reason : 'Unhandled promise rejection');
    reportClientError({
      message: msg,
      stack: reason?.stack,
      source: 'unhandledrejection',
    });
  });
}
